module.exports = __webpack_public_path__ + "static/media/1.e1aa99e8.png";